import ReactFullpage from "@fullpage/react-fullpage";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import OnLeave from "./Components/animations/onLeave";
import SectionFive from "./Components/SectionFive/SectionFive";

import SectionExpertise from "./Components/SectionExpertise/SectionExpertise";
import SectionOne from "./Components/SectionOne/SectionOne";
import SectionPortfolio from "./Components/SectionPortfolio/SectionPortfolio";
import SectionTwo from "./Components/SectionTwo/SectionTwo";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

function Home() {
  const fullpageOptions = {
    anchors: ["firstPage", "secondPage", "expertisePage", "portfolioPage", "fivePage"],
  };

  return (
    <div className='page-home'>
      <ReactFullpage
        licenseKey={"263DXXXX-B839XXXX-AE67XXXX-F398XXXX"}
        {...fullpageOptions}
        navigation={true}
        scrollingSpeed={700}
        onLeave={OnLeave}
        // afterLoad={OnLoad}
        normalScrollElements={".itemList, .sp-col__list"}
        render={({ state, fullpageApi }) => {
          return (
            <>
              <div className='section'>
                <SectionOne />
              </div>

              <div className='section'>
                <SectionTwo />
              </div>

              <div className='section'>
                <SectionExpertise />
              </div>

              <div className='section'>
                <SectionPortfolio />
              </div>

              <div className='section'>
                <SectionFive />
              </div>
            </>
          );
        }}
      ></ReactFullpage>
    </div>
  );
}

export default Home;
